import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { AppAnalyticsInsertRequest } from "../models/request/appAnalyticsInsertRequest";
import { AndroidAppResponse } from "../models/response/androidAppResponse";

const androidAppApi = {
  getAndroidApp: async () => {
    var response = await apiClient.post<UnifiedResponse<AndroidAppResponse>>(
      "/app/check_latest_app_version",
      {
        data: {},
      },
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  insertAppAnalytics: async (data: AppAnalyticsInsertRequest) => {
    var response = await apiClient.post<UnifiedResponse<any>>(
      "/app/app_analytics/insert",
      data,
    );
    return response.data;
  },
};

export default androidAppApi;
